import { render } from "./IconSortDown.vue?vue&type=template&id=993b8368"
const script = {}

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__